import styled from "styled-components";

export const Styles = styled.div`
  direction: ${({ isAr }) => (isAr ? "rtl" : "ltr")};

  .donation-details-card {
    background: white;
    border-radius: ${({ $isInDetailsPage }) => ($isInDetailsPage ? "0" : "12px")};
    box-shadow: ${({ $isInDetailsPage }) => ($isInDetailsPage ? "none" : "0 4px 20px rgba(0, 0, 0, 0.08)")};
    max-width: 420px;
    margin: 0 auto;
  }

  .details-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-direction: ${({ isAr }) => (isAr ? "row-reverse" : "row")};
    border-bottom: 1px solid #e2e8f0;
    padding-inline: 3rem;
    padding-block: 1rem;
    position: relative;
  }

  .details-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a202c;
    margin: 0;
    flex: 1;
    text-align: center;
  }

  .details-back {
    position: absolute;
    ${({ isAr }) => (isAr ? "right: 10px;" : "left: 10px;")}
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background: transparent;
    color: #718096;
    cursor: pointer;
    border-radius: 6px;
    transition:
      color 0.2s,
      background 0.2s;

    .details-back-arrow {
      font-size: 1.6rem;
      line-height: 1;
      margin-top: -3px;
    }
  }

  .details-back:hover {
    background: #f7fafc;
    color: #2d3748;
  }

  .details-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    padding: 2rem;
    padding-top: 1rem;
  }

  .details-field {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
  }

  .details-field label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #4a5568;
    margin-bottom: .5rem;
    text-align: ${({ isAr }) => (isAr ? "right" : "left")};
  }

  .details-field .field-container {
    margin-top: 0;
  }

  /* Match step-1 custom-amount-section input look: border, radius, padding */
  .details-field input,
  .details-field .form-control {
    width: 100% !important;
    padding: 0.5rem 1rem !important;
    font-size: 1rem !important;
    font-weight: 500 !important;
    border: 2px solid #e2e8f0 !important;
    border-radius: 6px !important;
    color: #2d3748 !important;
    background: white !important;
    transition:
      border-color 0.2s,
      background 0.2s;
    min-height: 48px;
  }

  .details-field input::placeholder,
  .details-field .form-control::placeholder {
    color: #cbd5e0 !important;
  }

  .details-field input:focus,
  .details-field .form-control:focus {
    outline: none !important;
    border-color: var(--main-color) !important;
    box-shadow: none !important;
  }

  .details-field input:disabled,
  .details-field .form-control:disabled {
    background: #f7fafc !important;
    color: #a0aec0 !important;
    cursor: not-allowed;
  }

  .details-field .error-message {
    color: var(--danger);
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }

  .details-checkbox {
    width: 100%;
  }

  .details-checkbox .field-container {
    margin-top: 0;
  }

  .details-checkbox input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: var(--main-color);
  }

  .details-checkbox label {
    font-size: 0.875rem;
    color: #4a5568;
    cursor: pointer;
  }

  .details-submit {
    width: 100%;
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
    font-weight: 600;
    color: white;
    background: var(--main-color);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition:
      opacity 0.2s,
      background 0.2s;
    margin-top: 0.25rem;
  }

  .details-submit:hover:not(:disabled) {
    opacity: 0.95;
  }

  .details-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
